import { render, staticRenderFns } from "./TeamsInstructions.vue?vue&type=template&id=4c35e718&scoped=true"
import script from "./TeamsInstructions.vue?vue&type=script&lang=js"
export * from "./TeamsInstructions.vue?vue&type=script&lang=js"
import style0 from "./TeamsInstructions.vue?vue&type=style&index=0&id=4c35e718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c35e718",
  null
  
)

export default component.exports